import { useEffect, useRef } from "react";
import { useInView } from "framer-motion";

export default function CountUp({
  to,
  from = 0,
  duration = 1,
  delay = 0,
  separator = "",
  decimals, // optional，若沒提供自動推算
  className = "",
  startWhen = true,
  onStart,
  onEnd,
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (!isInView || !startWhen) return;

    if (typeof onStart === "function") onStart();

    const startTime = performance.now() + delay * 1000;

    const getDecimalPlaces = () => {
      if (typeof decimals === "number") return decimals;
      const str = to.toString();
      const dotIndex = str.indexOf(".");
      return dotIndex >= 0 ? str.length - dotIndex - 1 : 0;
    };

    const decimalPlaces = getDecimalPlaces();

    const padDecimals = (num) => {
      const parts = String(num).split(".");
      const decimalPart = parts[1] || "";
      return (
        parts[0] +
        (decimalPlaces > 0
          ? "." +
            decimalPart.padEnd(decimalPlaces, "0").substring(0, decimalPlaces)
          : "")
      );
    };

    const frame = (now) => {
      if (!ref.current) return;

      if (now < startTime) {
        requestAnimationFrame(frame);
        return;
      }

      const progress = Math.min((now - startTime) / (duration * 1000), 1);
      const current = from + (to - from) * progress;

      const padded = padDecimals(current);

      const [intPart, decimalPart] = padded.split(".");
      const formattedInt = separator
        ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator)
        : intPart;

      const result =
        decimalPlaces > 0 && decimalPart != null
          ? `${formattedInt}.${decimalPart}`
          : formattedInt;

      ref.current.textContent = result;

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else if (typeof onEnd === "function") {
        onEnd();
      }
    };

    requestAnimationFrame(frame);
  }, [
    isInView,
    startWhen,
    from,
    to,
    delay,
    onStart,
    onEnd,
    duration,
    separator,
    decimals,
  ]);

  return <span ref={ref} className={className} />;
}
